/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toggle_DetailsInputs */

const en_notifications_toggle_details = /** @type {(inputs: Notifications_Toggle_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle notification details`)
};

const pt_br2_notifications_toggle_details = /** @type {(inputs: Notifications_Toggle_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar detalhes da notificação`)
};

/**
* | output |
* | --- |
* | "Toggle notification details" |
*
* @param {Notifications_Toggle_DetailsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_toggle_details = /** @type {((inputs?: Notifications_Toggle_DetailsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toggle_DetailsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_toggle_details(inputs)
	return pt_br2_notifications_toggle_details(inputs)
});